<template>
  <modal-v2
    ref="modal"
    size="medium"
    textAlign="left"
    auto-body-height
  >
    <template #header>
      <img src="/images/shipping-companies/loggi.png" alt="Logo Loggi" style="max-width: 200px; margin-bottom: 1.5rem;">

      <h2>Geração de etiquetas para Coleta da Loggi</h2>
    </template>

    <template #body>
      <p class="mb-4">Depois de gerar suas etiquetas, a coleta será programada para o endereço de remetente.</p>
      <p class="mb-4"><strong>É importante saber:</strong></p>
      <ul>
        <li>Para que a sua remessa seja coletada no <strong>mesmo dia</strong>, você deve gerar as etiquetas <strong>antes das 11h</strong>. Após este horário, a coleta é programada para o próximo dia útil.</li>
        <li>As coletas ocorrem em dias úteis no <strong>período da tarde (13h - 18h)</strong></li>
        <li>Para uma boa coleta, os envios devem estar embalados e etiquetados corretamente. É possível que mais de um motorista realize a coleta em seu endereço.</li>
      </ul>
    </template>

    <template #footer>
      <button type="button" class="mui-button mui-button--minimal" @click.prevent="$emit('close-modal')">
        Revisar
      </button>
      <button type="button" class="mui-button mui-button--primary" @click="$emit('continue', order)">
        Gerar etiquetas
      </button>
    </template>
  </modal-v2>
</template>

<script>
import ModalV2 from 'commons/js/components/atoms/ModalV2';

export default {
  components: {
    ModalV2,
  },

  props: ['order'],

  methods: {
    open() {
      this.$refs.modal.open();
    },

    close() {
      this.$refs.modal.close();
    },
  }
}
</script>
